import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { adminLogin, formatApiError } from "@/lib/adminApi";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(email.trim().toLowerCase(), password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-gradient-to-br from-[#0B192C] via-[#173F5F] to-[#0E7C8F] flex items-center justify-center px-6 py-12 text-[#F9F8F6]"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="overline text-[#E89B6C]">Area riservata</p>
          <h1 className="font-serif-display text-4xl md:text-5xl mt-3 leading-tight">
            Accesso <em className="text-[#E89B6C]">admin</em>
          </h1>
          <p className="mt-3 text-sm font-light text-[#F9F8F6]/70">
            Solo per l'amministratore di Metodo di Mare.
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#F9F8F6]/8 backdrop-blur-md border border-[#F9F8F6]/15 p-8 md:p-10 space-y-5"
        >
          <div>
            <label
              htmlFor="admin-email"
              className="overline block mb-2 text-[#F9F8F6]/80"
            >
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-transparent border-0 border-b border-[#F9F8F6]/30 py-3 text-base font-light text-[#F9F8F6] placeholder:text-[#F9F8F6]/40 focus:outline-none focus:border-b-2 focus:border-[#E89B6C]"
              placeholder="metododimare@gmail.com"
            />
          </div>
          <div>
            <label
              htmlFor="admin-password"
              className="overline block mb-2 text-[#F9F8F6]/80"
            >
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-transparent border-0 border-b border-[#F9F8F6]/30 py-3 text-base font-light text-[#F9F8F6] placeholder:text-[#F9F8F6]/40 focus:outline-none focus:border-b-2 focus:border-[#E89B6C]"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p
              data-testid="admin-login-error"
              className="text-sm text-[#FF8B6E] font-light"
            >
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="group w-full inline-flex items-center justify-center gap-3 px-7 py-4 bg-[#E89B6C] text-[#0B192C] text-xs uppercase tracking-[0.2em] hover:bg-[#F9F8F6] transition-all disabled:opacity-60"
          >
            {loading ? (
              <>
                <Loader2 size={14} className="animate-spin" />
                Accesso in corso...
              </>
            ) : (
              <>
                <Lock size={14} />
                Accedi
                <ArrowRight
                  size={14}
                  className="transition-transform group-hover:translate-x-1"
                />
              </>
            )}
          </button>
        </form>

        <p className="text-center mt-8 text-[10px] uppercase tracking-[0.18em] text-[#F9F8F6]/50">
          Sessione protetta · JWT · bcrypt
        </p>
      </div>
    </main>
  );
}
